var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 126,
    viewBox: "0 0 220 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.678 68.3702C105.988 60.9502 112.528 55.2402 120.298 55.2402C128.068 55.2402 134.608 60.9502 135.918 68.3702",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.779 72.7502H101.819C100.849 72.7502 100.059 71.9602 100.059 70.9902V70.1302C100.059 69.1602 100.849 68.3702 101.819 68.3702H138.779C139.749 68.3702 140.539 69.1602 140.539 70.1302V70.9902C140.539 71.9602 139.749 72.7502 138.779 72.7502Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.168 63.8503L131.658 55.9103",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.848 55.2502L121.698 49.6802",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.598 54.3702L111.738 57.7202",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.469 54.6603L117.569 61.8103",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.509 55.4002C110.415 55.4002 111.149 54.666 111.149 53.7602C111.149 52.8545 110.415 52.1202 109.509 52.1202C108.603 52.1202 107.869 52.8545 107.869 53.7602C107.869 54.666 108.603 55.4002 109.509 55.4002Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.829 55.4002C115.735 55.4002 116.469 54.666 116.469 53.7602C116.469 52.8545 115.735 52.1202 114.829 52.1202C113.924 52.1202 113.189 52.8545 113.189 53.7602C113.189 54.666 113.924 55.4002 114.829 55.4002Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.238 51.0202C122.143 51.0202 122.878 50.286 122.878 49.3802C122.878 48.4745 122.143 47.7402 121.238 47.7402C120.332 47.7402 119.598 48.4745 119.598 49.3802C119.598 50.286 120.332 51.0202 121.238 51.0202Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.179 56.3402C133.085 56.3402 133.819 55.6059 133.819 54.7002C133.819 53.7944 133.085 53.0602 132.179 53.0602C131.273 53.0602 130.539 53.7944 130.539 54.7002C130.539 55.6059 131.273 56.3402 132.179 56.3402Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11 95.0903L127.78 93.5303L124.6 101.74L138.93 111.67C138.93 111.67 146.01 113.37 148.78 105.74C151.55 98.1103 144.11 95.0903 144.11 95.0903ZM144.4 104.54C143.1 107.8 139.93 107.17 139.93 107.17L131.13 101.12L132.14 98.0103L142.72 99.5003C142.72 99.5103 145.53 101.7 144.4 104.54Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.14 111.3L124.62 102.01L117.85 107.64L125.56 123.28C125.56 123.28 130.92 128.2 137.05 122.88C143.18 117.56 138.14 111.3 138.14 111.3ZM133.81 119.7C131.09 121.92 128.63 119.83 128.63 119.83L123.87 110.27L126.27 108.04L134.79 114.48C134.79 114.49 136.18 117.77 133.81 119.7Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.169 93.5003L124.959 102.02L117.919 108.03C117.919 108.03 82.0487 81.1303 86.5887 75.0403C91.1187 68.9503 128.169 93.5003 128.169 93.5003Z",
    fill: "#96F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.509 97.0002C116.685 97.0002 117.639 96.0466 117.639 94.8702C117.639 93.6939 116.685 92.7402 115.509 92.7402C114.333 92.7402 113.379 93.6939 113.379 94.8702C113.379 96.0466 114.333 97.0002 115.509 97.0002Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 102.01L104.6 96.7502",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 97.3403C194.116 97.3403 206.661 84.7953 206.661 69.3203C206.661 53.8453 194.116 41.3003 178.641 41.3003C163.166 41.3003 150.621 53.8453 150.621 69.3203C150.621 84.7953 163.166 97.3403 178.641 97.3403Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.72 45.0403L158.09 88.6203",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45 47.5303L161.83 91.1103",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.191 51.2603L166.811 93.6003",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.921 55.0002L170.551 94.8502",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.09 51.2603L176.77 63.7203",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.359 55.0002L174.279 67.4502",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.109 58.7402L170.549 71.1902",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.871 63.7202L168.061 74.9202",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42 67.4502L187.98 73.6802",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.66 71.1902L184.25 78.6602",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42 74.9203L180.51 83.6403",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.169 79.9103L175.529 88.6203",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.08 46.2803L180.51 58.7403",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.061 43.7903L184.251 55.0003",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.939 48.7702L216.619 28.8502",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.891 32.5802L160.581 47.5302",
    stroke: "#0CA678",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25 30.7202C218.625 30.7202 219.74 29.6054 219.74 28.2302C219.74 26.855 218.625 25.7402 217.25 25.7402C215.875 25.7402 214.76 26.855 214.76 28.2302C214.76 29.6054 215.875 30.7202 217.25 30.7202Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.02 33.8302C146.738 33.8302 148.13 32.4378 148.13 30.7202C148.13 29.0026 146.738 27.6102 145.02 27.6102C143.303 27.6102 141.91 29.0026 141.91 30.7202C141.91 32.4378 143.303 33.8302 145.02 33.8302Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5802 31.3499L21.7002 38.1799L20.6602 54.4499L30.2602 50.7199L21.5502 59.4299L37.6402 87.4499L42.8202 82.0699L56.4202 86.8299L61.4002 80.5999L86.9202 70.9899L93.7502 52.5799L83.8102 49.7699L94.9702 30.7899L77.8102 20.8299L68.8002 28.2999L61.4002 11.8799L29.0202 24.5699V35.7699",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5802 31.3499L21.7002 38.1799L20.6602 54.4499L30.2602 50.7199L21.5502 59.4299L37.6402 87.4499L42.8202 82.0699L56.4202 86.8299L61.4002 80.5999L86.9202 70.9899L93.7502 52.5799L83.8102 49.7699L94.9702 30.7899L77.8102 20.8299L68.8002 28.2999L61.4002 11.8799L29.0202 24.5699V35.7699",
    stroke: "#63E6BE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6598 78.1099C72.102 78.1099 83.8098 66.4022 83.8098 51.9599C83.8098 37.5177 72.102 25.8099 57.6598 25.8099C43.2175 25.8099 31.5098 37.5177 31.5098 51.9599C31.5098 66.4022 43.2175 78.1099 57.6598 78.1099Z",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5098 64.6299C76.5398 74.0199 67.2498 80.5999 56.4098 80.5999C41.9698 80.5999 30.2598 68.8899 30.2598 54.4499C30.2598 49.6899 31.5298 45.2199 33.7598 41.3699",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1699 23.3198H61.3999",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49 66.6099C69.49 66.6099 85.08 55.6999 78.84 51.9599C72.6 48.2199 73.22 41.3799 73.22 41.3799L65.75 46.3599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4301 43.7399C39.8001 43.0299 40.9101 43.4699 41.4301 44.0799C43.2701 46.2099 43.5701 49.5399 42.1501 51.9699C41.3501 49.6699 39.0101 47.9899 36.5801 47.9599C37.2301 52.7799 41.6801 56.7899 46.5301 56.9599C44.4901 57.4299 42.4501 57.9099 40.4101 58.3799C41.8101 60.3599 44.8701 59.5499 47.2401 60.0699C49.5301 60.5699 51.2501 62.4199 52.8001 64.1799C52.9101 64.3099 53.0301 64.4399 53.1401 64.5599C54.3001 65.8699 55.4701 67.1799 56.6301 68.4899C55.0601 67.8199 53.1801 69.8999 54.0001 71.3899C54.8201 72.8799 57.5801 72.4299 57.8601 70.7499C58.7901 71.4799 60.3901 70.9899 60.7401 69.8599C61.3401 71.1599 63.6801 70.9299 64.0101 69.5299C64.7301 70.3499 66.4001 69.5099 66.1701 68.4399C66.9201 69.2399 68.5601 68.4399 68.4001 67.3599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0401 45.2499C54.6201 42.4599 56.2001 39.4799 58.7401 38.2499C58.0001 38.1999 57.3801 37.4399 57.4801 36.7099C57.5801 35.9799 58.3801 35.4099 59.1101 35.5599C59.4701 35.6299 59.7901 35.8499 60.0301 36.1299C60.5001 36.6599 60.7001 37.4999 60.3201 38.1099C59.9401 38.7199 58.9301 38.8599 58.5201 38.2699",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4902 43.9999C62.9502 42.2099 64.4902 40.4799 66.1002 38.8299C65.1502 38.7899 64.7402 37.2899 65.5102 36.7299C66.2702 36.1699 67.5402 36.8799 67.5302 37.8299C67.5102 38.7799 66.3302 39.4599 65.4602 39.0599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5093 40.2799C51.6093 39.1299 50.9493 37.7999 50.5893 36.3799C50.4693 35.8999 50.3893 35.3799 50.6093 34.9399C50.6993 34.7599 50.8393 34.5999 50.8593 34.3999C50.8993 34.0999 50.6693 33.8499 50.4493 33.6399C50.0893 33.2799 49.6893 32.9099 49.1793 32.8399C48.1693 32.6999 47.4093 34.0699 47.9393 34.9399C48.4693 35.8099 49.8393 35.8799 50.5993 35.1999C50.6793 34.8799 50.7593 34.5499 50.8293 34.2299",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4194 61.7899C59.6694 61.7599 59.0994 62.7199 59.4694 63.3599C59.8994 63.8899 60.8894 63.5399 61.0694 62.8799C61.2494 62.2199 60.7894 61.5199 60.1894 61.1899C60.0294 61.0999 59.7694 61.0599 59.6994 61.2299C59.6294 61.3999 60.0394 61.3699 59.8894 61.2599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6204 56.9999C60.2704 57.3299 60.5004 58.0099 60.9704 58.1199C61.4404 58.2199 61.9204 57.7799 61.9104 57.3099C61.9104 56.8299 61.4804 56.4199 61.0104 56.3499",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6799 59.6899C62.3099 60.0299 62.7799 60.7499 63.2799 60.6599C63.7799 60.5699 64.0499 59.9699 63.9499 59.4699C63.8799 59.0899 63.5999 58.7299 63.2299 58.6699C62.8499 58.5999 62.4299 58.9499 62.4999 59.3199",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6492 66.5499C44.2092 65.5099 45.5092 65.0299 46.6892 65.1299C47.8692 65.2299 48.9492 65.8099 49.9392 66.4499C47.7892 67.2099 45.4292 67.3599 43.1992 66.8699",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6309 67.1398C48.2309 68.1798 47.6009 70.1498 48.1509 71.7998C49.8209 70.7198 50.5509 68.3998 49.8109 66.5698",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1198 50.5999C45.5298 52.2199 44.8598 53.8099 44.0898 55.3599C44.1598 54.8099 44.2298 54.2599 44.2898 53.7199",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3399 48.7499C45.0299 49.9899 44.5499 51.1899 43.9199 52.2999",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3011 46.0399C44.8211 47.1499 44.3511 48.2499 43.8711 49.3599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.461 44.1799C44.181 45.1299 43.791 46.0499 43.291 46.9099",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6311 43.1399C43.2911 43.8299 42.9611 44.5299 42.6211 45.2199",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3993 42.1099C42.3493 42.7699 42.1393 43.4199 41.7793 43.9699",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5796 41.4999C41.2596 41.8199 41.0996 42.2899 41.1496 42.7399",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1811 49.3599C46.5211 51.4999 46.0811 53.6999 45.8711 55.9199C45.9611 55.7299 46.0411 55.5399 46.1311 55.3599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9904 53.0798C48.6904 54.9798 48.5704 56.8998 48.6204 58.8198C48.6204 58.6298 48.6204 58.4498 48.6204 58.2598",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5108 49.7699C51.4908 50.5999 51.5708 51.4399 51.7708 52.2499",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0508 56.6099C50.3308 57.8499 50.5608 59.1099 50.7508 60.3699C50.8008 60.2899 50.8508 60.2099 50.9008 60.1299",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7109 55.9899C51.7309 56.7499 51.7409 57.4999 51.7609 58.2599C52.1709 57.9499 51.6109 57.1599 51.1809 57.4499C50.7509 57.7399 51.2909 58.5599 51.7309 58.2799",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7694 55.5698C52.7394 56.0898 52.7394 56.6098 52.7794 57.1298C52.7894 57.2098 52.7994 57.2998 52.8794 57.3298C52.9594 57.3598 53.0094 57.1998 52.9294 57.2098",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3711 57.0199C47.3711 57.6399 47.3711 58.2599 47.3711 58.8799",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1595 57.8599C46.0895 58.1299 46.0095 58.4099 45.9395 58.6799",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9698 39.6899C55.4998 39.2599 54.9398 38.9299 54.3398 38.7199C54.8498 38.8599 55.4198 38.3499 55.3298 37.8299C55.2398 37.3099 54.5298 37.0199 54.0998 37.3199C53.6698 37.6299 53.7098 38.3999 54.1798 38.6499",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5499 51.6399C39.5099 51.9799 39.4599 52.3199 39.4199 52.6599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1309 60.9498C52.2709 61.4298 52.4109 61.9198 52.5409 62.3998",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 60.5499C53.5406 61.8699 53.9406 63.1799 54.3506 64.4999",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0293 62.3999C55.1993 63.7399 55.4593 65.0699 55.7993 66.3799C55.8393 66.5299 55.8993 66.7099 56.0493 66.7599C56.1993 66.8199 56.3893 66.6199 56.2793 66.5099C56.2093 66.6599 56.1393 66.7999 56.0693 66.9499",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8711 62.6199C58.0711 65.2199 58.6311 67.7999 59.5311 70.2499C59.5511 70.0299 59.5811 69.7999 59.6011 69.5799C59.6011 69.8099 59.5911 70.0499 59.5911 70.2799",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 67.9899C60.14 68.3399 60.28 68.6799 60.41 69.0299",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2207 61.5798C61.5407 62.7998 61.7807 64.0298 61.9307 65.2798C62.0807 65.1298 62.1307 64.8798 62.0507 64.6798",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4902 61.7799C62.7202 62.4799 62.9602 63.1899 63.1902 63.8899",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5898 59.4999C65.5898 59.8499 65.5898 60.1899 65.5898 60.5399",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8594 69.0299C56.0094 69.7899 56.1494 70.5499 56.2994 71.2999",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0293 69.6499C55.0293 70.0599 55.0293 70.4799 55.0293 70.8899",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4205 59.0898C42.2805 59.2098 42.4405 59.4498 42.6205 59.4598C42.8005 59.4698 42.9505 59.3198 43.0705 59.1998C42.9205 59.2998 42.7605 59.4098 42.6105 59.5098",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4004 59.0898C42.7404 58.9198 43.0804 58.7498 43.4304 58.5798C43.0904 58.7498 42.7404 58.9198 42.4004 59.0898Z",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0292 55.3599C54.8292 54.9199 54.5392 54.5199 54.1992 54.1899C54.2692 54.9299 54.4292 55.6599 54.6692 56.3599C54.9892 55.5199 55.2492 54.6499 55.4392 53.7699C55.5092 54.0699 55.5792 54.3699 55.6592 54.6799C55.7292 54.3099 55.8192 53.9499 55.9192 53.5899C55.9492 53.4699 56.1792 53.5699 56.0592 53.5599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2001 67.7699C48.8301 68.8299 48.7001 69.9799 48.8401 71.0899",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9505 35.6998C57.8305 36.3398 57.9105 37.0098 58.1905 37.5998C58.5905 37.2198 58.8705 36.7198 58.9905 36.1798C59.0205 36.8598 59.2805 37.5198 59.7105 38.0498",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.13 37.2199C66.2 37.2399 66.16 37.0899 66.09 37.1099C66.02 37.1299 66.01 37.2299 66.01 37.2999C66.01 37.7699 66 38.2499 66 38.7199C66.16 38.6899 66.21 38.4899 66.24 38.3299C66.27 38.1699 66.33 37.9699 66.5 37.9599C66.66 37.9399 66.65 38.2899 66.51 38.1999C66.55 38.0499 66.59 37.9099 66.63 37.7599",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4298 33.8298C49.3598 34.1498 49.2798 34.4798 49.2098 34.7998C49.0898 34.3598 48.9698 33.9098 48.8598 33.4698C48.7698 33.7198 48.6798 33.9798 48.5898 34.2298",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 61.2198C58.7404 61.7298 58.4304 62.2398 58.1304 62.7498C58.2904 62.2498 58.1304 61.6598 57.7404 61.3098C57.2204 61.9598 57.1304 62.9198 57.5204 63.6498",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8204 68.3799C57.7304 68.8599 57.6804 69.3499 57.6804 69.8399C57.4304 69.4399 57.1904 69.0299 56.9404 68.6299C56.9104 69.0299 56.8804 69.4299 56.8504 69.8399C56.7304 69.4199 56.5204 69.0199 56.2604 68.6799C56.1404 69.0799 56.0204 69.4699 55.9004 69.8699",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8205 54.3298C65.5705 52.3498 66.2505 50.2798 67.6205 48.8298C67.7105 49.8298 67.8105 50.8498 67.5905 51.8198C67.3705 52.7998 66.7905 53.7498 65.8705 54.1498C66.3105 52.5698 66.7505 50.9898 67.1905 49.4098C66.5805 50.7298 66.2405 52.1898 66.2105 53.6398C66.4405 52.6798 66.7905 51.7398 67.2505 50.8698C67.2705 51.5398 67.1905 52.2198 67.0005 52.8598",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4493 55.9898C68.5793 57.1598 70.8493 56.8098 71.5693 55.3498C70.0693 55.0398 68.4893 55.1198 67.0293 55.5898C68.1093 56.6298 70.0293 56.6098 71.0893 55.5498C69.8693 55.5098 68.6493 55.7198 67.5193 56.1698C68.4793 56.3698 69.5193 56.1698 70.3393 55.6198C69.5793 55.6998 68.8193 55.7798 68.0593 55.8598",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9005 53.4798C70.1305 53.2098 71.1605 52.1598 71.4005 50.9198C70.4105 51.6698 69.5305 52.5498 68.7705 53.5298C69.4805 52.6898 70.1905 51.8498 70.9005 51.0098C69.9705 51.7598 69.1505 52.6498 68.4805 53.6398C68.6305 52.3198 69.6605 51.1498 70.9405 50.8198C70.5505 51.5198 70.1605 52.2098 69.7805 52.9098",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1699 22.0798H53.9199V24.5698H55.1699V22.0798Z",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0195 21.4498V25.1898",
    stroke: "#12B886",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.451 19.527L115.865 22.752L119.09 28.3377L124.676 25.1127L121.451 19.527Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5841 85.7342L19.1055 83.9795L17.3508 88.4581L21.8294 90.2128L23.5841 85.7342Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23859 62.8904L1.22859 58.6504L0.558594 65.9804L7.23859 62.8904Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3597 117.7L67.3497 113.46L66.6797 120.78L73.3597 117.7Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7578 7.5C81.8624 7.5 82.7578 6.60457 82.7578 5.5C82.7578 4.39543 81.8624 3.5 80.7578 3.5C79.6532 3.5 78.7578 4.39543 78.7578 5.5C78.7578 6.60457 79.6532 7.5 80.7578 7.5Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0102 106.36C93.8938 106.36 94.6102 105.644 94.6102 104.76C94.6102 103.876 93.8938 103.16 93.0102 103.16C92.1265 103.16 91.4102 103.876 91.4102 104.76C91.4102 105.644 92.1265 106.36 93.0102 106.36Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4492 0.660156L35.2492 15.8502",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0293 125.16L73.6193 103.26",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 123.24L57.9981 104.08",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLeftImage);
export default __webpack_public_path__ + "static/media/otherLeftImage.e801bf12a631dae0f08f4319bb8ee08f.svg";
export { ForwardRef as ReactComponent };